import { contractTabItems } from 'src/app/models/contractTabItems-enum';

export const CONTRACT_MENU_TAB_OPTIONS = {
  ASSETS: 'Assets',
  PAYMENT_SCHEDULE: 'PaymentSchedule',
  COLLATERALS: 'Collaterals',
  INSURANCES: 'Insurances',
};

export const CONTRACT_MENU_TAB_ITEMS = [
  {
    value: contractTabItems.Assets,
    label: 'contractDetail.assets.n',
    key: CONTRACT_MENU_TAB_OPTIONS.ASSETS,
    isVisible: true,
    iconName: 'icon-car',
  },
  {
    value: contractTabItems.PaymentSchedule,
    label: 'contractDetail.paymentSchedule.n',
    key: CONTRACT_MENU_TAB_OPTIONS.PAYMENT_SCHEDULE,
    isVisible: true,
    iconName: 'icon-calendar',
  },
  {
    value: contractTabItems.Collaterals,
    label: 'contractDetail.collaterals.n',
    key: CONTRACT_MENU_TAB_OPTIONS.COLLATERALS,
    isVisible: true,
    iconName: 'icon-shield',
  },
  {
    value: contractTabItems.Insurances,
    label: 'contractDetail.insurances.n',
    key: CONTRACT_MENU_TAB_OPTIONS.INSURANCES,
    isVisible: true,
    iconName: 'icon-insurance',
  },
];
